import { extractTextFromQuery } from '../../../utils/query';

export default {
  param: extractTextFromQuery,
  having: function (text) {
    const words = text.trim().split(' ');

    if (text) {
      return {
        $or: words.map(function(word){
          return {
            interactionDescription: {
              $ilike: `%${word}%`
            }
          };
        })
      }
    }
  }
}
